/**
 * Global Timeline Page
 * 
 * A dedicated page for exploring the comprehensive timeline data
 * from all megalithic sites in the database.
 */

import React from 'react';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Button,
  HStack,
  useColorModeValue,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowLeft, Clock } from '@phosphor-icons/react';
import GlobalTimeline from '../components/timeline/GlobalTimeline';

const GlobalTimelinePage = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.700', 'gray.200');

  return (
    <Box minH="100vh" bg={bgColor}>
      <Container maxW="7xl" py={8}>
        <VStack spacing={6} align="stretch">
          {/* Breadcrumb Navigation */}
          <Breadcrumb>
            <BreadcrumbItem>
              <BreadcrumbLink as={RouterLink} to="/">
                Home
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink>Global Timeline</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>

          {/* Page Header */}
          <Box>
            <HStack spacing={4} mb={4}>
              <Button
                as={RouterLink}
                to="/"
                variant="ghost"
                leftIcon={<ArrowLeft size={20} />}
                size="sm"
              >
                Back to Home
              </Button>
            </HStack>
            
            <VStack align="start" spacing={3}>
              <HStack>
                <Clock size={32} />
                <Heading size="xl" color={textColor}>
                  Global Megalithic Timeline
                </Heading>
              </HStack>
              
              <Text color="gray.500" fontSize="lg" maxW="3xl">
                Explore the comprehensive timeline of megalithic construction periods from sites 
                around the world. Discover patterns across cultures, regions, and historical eras 
                to understand the global development of megalithic architecture.
              </Text>
            </VStack>
          </Box>

          {/* Main Timeline Component */}
          <GlobalTimeline />
        </VStack>
      </Container>
    </Box>
  );
};

export default GlobalTimelinePage;